import { useEffect, useRef } from "react";
import { trapEvent } from "../../../utils/EventHelpers";
const useQuickFindPosition = ({ tooltipPosition, quickFindPosition, }) => {
    if (tooltipPosition && !quickFindPosition) {
        if (tooltipPosition === "top" || tooltipPosition.includes("Top")) {
            return "top";
        }
        else if (tooltipPosition === "bottom" || tooltipPosition.includes("Bottom")) {
            return "bottom";
        }
    }
    return quickFindPosition || "bottom";
};
const useQuickFind = (props) => {
    const { handleQuickFind } = props;
    const position = useQuickFindPosition(props);
    const ref = useRef(null);
    const onShiftTab = (e, callback) => {
        var _a;
        if (e.key === "Tab" && e.shiftKey && handleQuickFind) {
            trapEvent(e);
            callback();
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
        }
    };
    useEffect(() => {
        var _a;
        handleQuickFind && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true }));
    }, []);
    return { ref, position, onShiftTab };
};
export default useQuickFind;
//# sourceMappingURL=useQuickFind.js.map